import { render, staticRenderFns } from "./featured-destinations.vue?vue&type=template&id=4838e248"
import script from "./featured-destinations.vue?vue&type=script&lang=js"
export * from "./featured-destinations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports